import React, { useState } from "react";
import { Accordion, Badge, Button } from "react-bootstrap";
import { formatPrice } from "utils/utils";
import ReservationIncomeForm from "./ReservationIncomeForm";
import { IconPlus, IconEdit } from "@tabler/icons-react";

const DompetAkunting = ({
  dataPerPaymentMethod,
  calculateNetKuber,
  getTextColor,
  onRefreshData,
}) => {
  const [showReservationIncomeModal, setShowReservationIncomeModal] =
    useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const handleCreateReservationIncome = (booking) => {
    setSelectedBooking(booking);
    setShowReservationIncomeModal(true);
  };

  const handleUpdateReservationIncome = (booking) => {
    setSelectedBooking(booking);
    setShowReservationIncomeModal(true);
  };

  const handleCloseReservationIncomeModal = () => {
    setShowReservationIncomeModal(false);
    setSelectedBooking(null);
  };

  return (
    <>
      <Accordion className="mb-4 bg-light">
        {Object.entries(dataPerPaymentMethod).map(
          ([paymentMethodName, paymentData], pmIndex) => (
            <Accordion.Item key={pmIndex} eventKey={pmIndex.toString()}>
              <Accordion.Header>
                <div className="d-flex justify-content-between align-items-center w-100 me-3 ">
                  <div>
                    <strong>{paymentMethodName}</strong>
                    <Badge bg="primary" className="ms-2 text-white">
                      {Number(paymentData.totals.count) || 0} transactions
                    </Badge>
                  </div>
                  {/* <div className="text-end">
                    <small className="text-muted">
                      Total:{" "}
                      {formatPrice(
                        Number(
                          paymentData.totals.totalPrice ||
                            paymentData.totals.payment_bill
                        ) || 0
                      )}
                    </small>
                  </div> */}
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="table-responsive bg-white">
                  <table className="table table-bordered table-hover table-sm">
                    <thead className="table-dark">
                      <tr>
                        <th>
                          Tgl
                        </th>
                        {/* <th>Transaksi ATV</th> */}
                        {/* <th>Payment Bill</th> */}
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentData.data.map((booking, index) => {
                        const globalIndex = `${pmIndex}-${index}`;
                        const qtyActivities =
                          booking.activities?.reduce(
                            (sum, activity) =>
                              sum +
                              ((activity.type === "product"
                                ? activity.qty
                                : 0) || 0),
                            0
                          ) || 0;
                        const othersValue = qtyActivities * 50000;

                        const netKuber = calculateNetKuber(booking);

                        return (
                          <tr key={index}>
                            <td>
                              <strong>{booking.code}</strong>
                            </td>
                            <td className="text-end">
                              <div className="text-end border-0">
                                <strong>
                                  {formatPrice(
                                    Number(booking.split_amount) || 0
                                  )}
                                </strong>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot className="table-secondary">
                      <tr>
                        <th colSpan="">SUBTOTAL - {paymentMethodName}</th>
                        <th className="text-end">
                          {formatPrice(
                            paymentData.data.reduce((sum, booking) => {
                              return sum + (Number(booking.payment_bill) || 0);
                            }, 0)
                          )}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )
        )}
      </Accordion>

      <ReservationIncomeForm
        show={showReservationIncomeModal}
        onHide={handleCloseReservationIncomeModal}
        booking={selectedBooking}
        onSuccess={onRefreshData}
      />
    </>
  );
};

export default DompetAkunting;
